module.exports = __webpack_public_path__ + "img/sebrae-ba-logo.964afba9.png";